import script from "./AddTokenButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddTokenButton.vue?vue&type=script&setup=true&lang=ts"

import "./AddTokenButton.vue?vue&type=style&index=0&id=f57342d8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f57342d8"]])

export default __exports__